/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Box } from '@material-ui/core';
import { Card } from '@roc/ui';
import { makeStyles } from '@material-ui/core/styles';
import { DateFormat, formatDate } from '@roc/client-portal-shared/utils';
import { formatCurrency } from '@roc/ui/utils';

const useStyles = makeStyles(theme => ({
  detailCard: {
    borderRadius: 0,
    boxShadow: '0px 2px 3px #EEE',
    padding: '16px',
  },
  row: {
    marginBottom: theme.spacing(1),
  },
  label: {
    fontWeight: 'bold',
  },
  noteCard: {
    borderRadius: 0,
    boxShadow: '0px 2px 3px #EEE',
  },
  noteHeader: {
    padding: '8px 16px',
    paddingBottom: '2px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
}));

export const RealEstateTransactionCard = ({
  realEstateTransaction,
  editRealEstateTransactionStore,
}) => {
  const classes = useStyles();
  const store = editRealEstateTransactionStore;
  const {
    propertyAddress,
    streetNumber,
    streetName,
    unit,
    city,
    state,
    zip,
    purchasePrice,
    mortgageAmount,
    mortgageDate,
    saleDate,
    lender,
    interestRate,
    ltc,
    arltv,
    ficoScore,
    purchaseDate,
    lendersUsed,
    transactionType,
  } = realEstateTransaction;

  const capitalizeWords = str =>
    str ? str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) : '';

  const propertyAddressFromDSApi = [
    [streetNumber, capitalizeWords(streetName)].filter(Boolean).join(' '),
    unit ? `Unit ${unit}` : null,
    [capitalizeWords(city), state?.toUpperCase(), zip]
      .filter(Boolean)
      .join(', '),
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <Card
      title={propertyAddress || propertyAddressFromDSApi}
      className={classes.noteCard}
      titleTypographyProps={{ variant: 'h6' }}
      cardHeaderProps={{
        className: classes.noteHeader,
      }}
      cardContentProps={{ style: { padding: '8px 16px' } }}
    >
      {propertyAddress ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
          {purchasePrice != null && purchasePrice !== '' && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Purchase Price:</span>{' '}
              {formatCurrency(Number(purchasePrice))}
            </Box>
          )}
          {mortgageAmount != null && mortgageAmount !== '' && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Mortgage Amount:</span>{' '}
              {formatCurrency(Number(mortgageAmount))}
            </Box>
          )}
          {interestRate != null && interestRate !== '' && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Interest Rate:</span>{' '}
              {interestRate}%
            </Box>
          )}
          {ltc != null && ltc !== '' && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>LTC:</span> {ltc}%
            </Box>
          )}
          {arltv != null && arltv !== '' && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>ARLTV:</span> {arltv}%
            </Box>
          )}
          {ficoScore != null && ficoScore !== '' && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>FICO Score:</span> {ficoScore}
            </Box>
          )}
          {purchaseDate && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Purchase Date:</span>{' '}
              {formatDate(purchaseDate, DateFormat.MMDDYYYY)}
            </Box>
          )}
          {saleDate && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Sale Date:</span>{' '}
              {formatDate(saleDate, DateFormat.MMDDYYYY)}
            </Box>
          )}
          {lendersUsed && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Lenders Used:</span> {lendersUsed}
            </Box>
          )}
          {transactionType && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Transaction Type:</span>{' '}
              {transactionType}
            </Box>
          )}
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
          {purchasePrice != null && purchasePrice !== '' && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Purchase Price:</span>{' '}
              {formatCurrency(Number(purchasePrice))}
            </Box>
          )}
          {mortgageAmount != null && mortgageAmount !== '' && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Mortgage Amount:</span>{' '}
              {formatCurrency(Number(mortgageAmount))}
            </Box>
          )}
          {saleDate && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Purchase Date:</span>{' '}
              {formatDate(saleDate, DateFormat.MMDDYYYY)}
            </Box>
          )}
          {mortgageDate && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Mortgage Date:</span>{' '}
              {formatDate(mortgageDate, DateFormat.MMDDYYYY)}
            </Box>
          )}
          {lender && (
            <Box className={classes.row} sx={{ width: '50%' }}>
              <span className={classes.label}>Lenders Used:</span> {lender}
            </Box>
          )}
        </Box>
      )}
    </Card>
  );
};
